const mrDurationToTotalResp = {
    error: null,
    overall: {
        value: 0.36214863116139995,
        significance: "moderate",
        explanation:
            "They are moderately positively correlated, potentially meaning that pull requests of bigger size may occasionally have a \n            higher chance to take significantly longer to be completed.",
        description:
            "For the entirety of time we have data on your Pull Requests, it seems that there is n moderately strong positive correlation between the lines of code in a pull request and the overall duration it takes for that pull request to be merged.that pull requests of bigger size may occasionally have a \n            higher chance to take significantly longer to be completed.\n            \n            However, note that correlation does not necessarily mean causation, so it is advisable to keep an eye on this if you want to validate it. And in that case you might want to keep an eye on your \n            Pull Requests size.\n            ",
        error: null,
    },
    smaller_frame: {
        value: 0.3790407418577887,
        significance: "moderate",
        explanation:
            "They are moderately positively correlated, potentially meaning that pull requests of bigger size may occasionally have a \n            higher chance to take significantly longer to be completed.",
        description:
            "For last 30 merged PRs, it seems that there is n moderately strong positive correlation between the lines of code in a pull request and the overall duration it takes for that pull request to be merged.that pull requests of bigger size may occasionally have a \n            higher chance to take significantly longer to be completed.\n            \n            However, note that correlation does not necessarily mean causation, so it is advisable to keep an eye on this if you want to validate it. And in that case you might want to keep an eye on your \n            Pull Requests size.\n            ",
        frame_name: "Last 30 merged PRs",
        error: null,
    },
    graph: {
        data: [
            {
                datetime: "2023-04-11T14:49:12.000Z",
                overall_duration: 940.0,
                total: 2,
                correlation: 0.5568127511,
                trend_line: 29.4785715658,
            },
            {
                datetime: "2023-04-11T17:34:35.000Z",
                overall_duration: 8671.0,
                total: 2,
                correlation: 0.5594351593,
                trend_line: 34.8881238475,
            },
            {
                datetime: "2023-04-11T18:45:25.000Z",
                overall_duration: 910.0,
                total: 0,
                correlation: 0.5620903829,
                trend_line: 29.4575442828,
            },
            {
                datetime: "2023-04-12T11:50:37.000Z",
                overall_duration: 5024.0,
                total: 0,
                correlation: 0.5644858126,
                trend_line: 32.3385188948,
            },
            {
                datetime: "2023-04-12T12:53:16.000Z",
                overall_duration: 26.0,
                total: 1,
                correlation: 0.5667516849,
                trend_line: 28.8378171331,
            },
            {
                datetime: "2023-04-12T12:53:41.000Z",
                overall_duration: 783.0,
                total: 2,
                correlation: 0.5688101731,
                trend_line: 29.3685257433,
            },
            {
                datetime: "2023-04-12T13:53:30.000Z",
                overall_duration: 325.0,
                total: 9,
                correlation: 0.5703767605,
                trend_line: 29.047457395,
            },
            {
                datetime: "2023-04-12T14:05:17.000Z",
                overall_duration: 36.0,
                total: 2,
                correlation: 0.5722037097,
                trend_line: 28.8448289536,
            },
            {
                datetime: "2023-04-12T15:44:21.000Z",
                overall_duration: 458.0,
                total: 3,
                correlation: 0.5738725063,
                trend_line: 29.1406999908,
            },
            {
                datetime: "2023-04-13T11:58:56.000Z",
                overall_duration: 605.0,
                total: 4,
                correlation: 0.5753991314,
                trend_line: 29.2437513212,
            },
            {
                datetime: "2023-04-20T09:50:44.000Z",
                overall_duration: 1814971.0,
                total: 198,
                correlation: 0.6231517993,
                trend_line: 465.4258901159,
            },
            {
                datetime: "2023-04-20T14:32:31.000Z",
                overall_duration: 2569.0,
                total: 8,
                correlation: 0.6244570197,
                trend_line: 30.6199405384,
            },
            {
                datetime: "2023-04-24T09:54:18.000Z",
                overall_duration: 423.0,
                total: 2,
                correlation: 0.6259385363,
                trend_line: 29.1161629885,
            },
            {
                datetime: "2023-04-24T13:01:11.000Z",
                overall_duration: 441.0,
                total: 1,
                correlation: 0.6273706987,
                trend_line: 29.1287820649,
            },
            {
                datetime: "2023-04-24T13:01:42.000Z",
                overall_duration: 2411495.0,
                total: 38,
                correlation: 0.5093250617,
                trend_line: 50.0104887537,
            },
            {
                datetime: "2023-04-24T14:11:41.000Z",
                overall_duration: 286.0,
                total: 19,
                correlation: 0.5100901901,
                trend_line: 29.0201145586,
            },
            {
                datetime: "2023-04-24T14:42:35.000Z",
                overall_duration: 593.0,
                total: 15,
                correlation: 0.5111088406,
                trend_line: 29.2353392147,
            },
            {
                datetime: "2023-04-25T13:24:30.000Z",
                overall_duration: 266.0,
                total: 53,
                correlation: 0.5082923129,
                trend_line: 29.0060924113,
            },
            {
                datetime: "2023-04-26T13:10:24.000Z",
                overall_duration: 82144.0,
                total: 6,
                correlation: 0.5091004457,
                trend_line: 85.359036648,
            },
            {
                datetime: "2023-05-05T11:29:01.000Z",
                overall_duration: 353.0,
                total: 7,
                correlation: 0.5104975014,
                trend_line: 29.0670878634,
            },
            {
                datetime: "2023-05-08T11:24:21.000Z",
                overall_duration: 256.0,
                total: 7,
                correlation: 0.5118318069,
                trend_line: 28.999081292,
            },
            {
                datetime: "2023-05-08T14:17:44.000Z",
                overall_duration: 3519.0,
                total: 7,
                correlation: 0.5119139798,
                trend_line: 31.285189623,
            },
            {
                datetime: "2023-05-08T14:45:30.000Z",
                overall_duration: 268.0,
                total: 1,
                correlation: 0.5144654592,
                trend_line: 29.0074946315,
            },
            {
                datetime: "2023-05-09T13:32:53.000Z",
                overall_duration: 587093.0,
                total: 730,
                correlation: 0.3968569368,
                trend_line: 376.6531252476,
            },
            {
                datetime: "2023-05-09T15:17:24.000Z",
                overall_duration: 273.0,
                total: 549,
                correlation: 0.3268668543,
                trend_line: 29.0110001767,
            },
            {
                datetime: "2023-05-10T11:26:49.000Z",
                overall_duration: 605.0,
                total: 180,
                correlation: 0.3519944077,
                trend_line: 29.2437513212,
            },
            {
                datetime: "2023-05-10T15:42:27.000Z",
                overall_duration: 318.0,
                total: 1,
                correlation: 0.3519936249,
                trend_line: 29.0425497406,
            },
            {
                datetime: "2023-05-10T16:57:41.000Z",
                overall_duration: 274.0,
                total: 8,
                correlation: 0.3531737866,
                trend_line: 29.0117012849,
            },
            {
                datetime: "2023-05-10T17:39:48.000Z",
                overall_duration: 284.0,
                total: 3,
                correlation: 0.3531734806,
                trend_line: 29.0187123494,
            },
            {
                datetime: "2023-05-11T13:55:19.000Z",
                overall_duration: 83014.0,
                total: 45,
                correlation: 0.3515661222,
                trend_line: 85.9461826349,
            },
            {
                datetime: "2023-05-11T14:08:55.000Z",
                overall_duration: 325.0,
                total: 40,
                correlation: 0.3505124641,
                trend_line: 29.047457395,
            },
            {
                datetime: "2023-05-11T15:17:09.000Z",
                overall_duration: 275.0,
                total: 92,
                correlation: 0.3486648409,
                trend_line: 29.0124023927,
            },
            {
                datetime: "2023-05-11T15:54:10.000Z",
                overall_duration: 51.0,
                total: 3,
                correlation: 0.3488459285,
                trend_line: 28.8553466271,
            },
            {
                datetime: "2023-05-12T16:18:00.000Z",
                overall_duration: 90556.0,
                total: 116,
                correlation: 0.3447092329,
                trend_line: 91.0255565369,
            },
            {
                datetime: "2023-05-12T16:31:41.000Z",
                overall_duration: 12219.0,
                total: 13,
                correlation: 0.3373573786,
                trend_line: 37.3645911626,
            },
            {
                datetime: "2023-05-12T16:58:12.000Z",
                overall_duration: 1030.0,
                total: 4,
                correlation: 0.3372947677,
                trend_line: 29.5416517674,
            },
            {
                datetime: "2023-05-12T17:15:23.000Z",
                overall_duration: 967.0,
                total: 11,
                correlation: 0.3380431202,
                trend_line: 29.4974958858,
            },
            {
                datetime: "2023-05-15T10:25:38.000Z",
                overall_duration: 1156.0,
                total: 114,
                correlation: 0.3327714359,
                trend_line: 29.6299598974,
            },
            {
                datetime: "2023-05-15T13:13:44.000Z",
                overall_duration: 640.0,
                total: 5,
                correlation: 0.3326868902,
                trend_line: 29.268286381,
            },
            {
                datetime: "2023-05-15T14:33:15.000Z",
                overall_duration: 5813.0,
                total: 72,
                correlation: 0.237761089,
                trend_line: 32.8904521225,
            },
            {
                datetime: "2023-05-15T14:36:55.000Z",
                overall_duration: 987.0,
                total: 48,
                correlation: 0.2362464802,
                trend_line: 29.5115137572,
            },
            {
                datetime: "2023-05-16T10:27:47.000Z",
                overall_duration: 1270.0,
                total: 188,
                correlation: 0.2264929779,
                trend_line: 29.7098535548,
            },
            {
                datetime: "2023-05-16T11:09:31.000Z",
                overall_duration: 766.0,
                total: 2,
                correlation: 0.2265813998,
                trend_line: 29.3566095024,
            },
            {
                datetime: "2023-05-16T12:33:18.000Z",
                overall_duration: 2214.0,
                total: 70,
                correlation: 0.2256721521,
                trend_line: 30.3712766472,
            },
            {
                datetime: "2023-05-16T13:31:03.000Z",
                overall_duration: 478.0,
                total: 4,
                correlation: 0.2259522936,
                trend_line: 29.1547209673,
            },
            {
                datetime: "2023-05-16T14:56:13.000Z",
                overall_duration: 287.0,
                total: 2,
                correlation: 0.2263166289,
                trend_line: 29.0208156628,
            },
            {
                datetime: "2023-05-16T17:20:18.000Z",
                overall_duration: 345.0,
                total: 76,
                correlation: 0.2241230274,
                trend_line: 29.0614791825,
            },
            {
                datetime: "2023-05-16T18:57:38.000Z",
                overall_duration: 326.0,
                total: 1,
                correlation: 0.2241774969,
                trend_line: 29.0481584873,
            },
            {
                datetime: "2023-05-16T19:41:41.000Z",
                overall_duration: 1038.0,
                total: 18,
                correlation: 0.2214915208,
                trend_line: 29.5472587768,
            },
            {
                datetime: "2023-05-16T20:16:56.000Z",
                overall_duration: 279.0,
                total: 210,
                correlation: 0.2112412678,
                trend_line: 29.0152068209,
            },
            {
                datetime: "2023-05-16T20:41:34.000Z",
                overall_duration: 287.0,
                total: 4,
                correlation: 0.2112075433,
                trend_line: 29.0208156628,
            },
            {
                datetime: "2023-05-17T08:47:41.000Z",
                overall_duration: 823.0,
                total: 29,
                correlation: 0.2106614672,
                trend_line: 29.3965636094,
            },
            {
                datetime: "2023-05-17T12:33:10.000Z",
                overall_duration: 7262.0,
                total: 35,
                correlation: 0.2097079605,
                trend_line: 33.9035810941,
            },
            {
                datetime: "2023-05-17T15:05:14.000Z",
                overall_duration: 513.0,
                total: 9,
                correlation: 0.2095905886,
                trend_line: 29.1792573826,
            },
            {
                datetime: "2023-05-17T16:20:56.000Z",
                overall_duration: 9741.0,
                total: 12,
                correlation: 0.2091807086,
                trend_line: 35.6353813709,
            },
            {
                datetime: "2023-05-18T13:24:42.000Z",
                overall_duration: 222.0,
                total: 9,
                correlation: 0.209028542,
                trend_line: 28.9752432581,
            },
            {
                datetime: "2023-05-19T11:24:36.000Z",
                overall_duration: 81699.0,
                total: 113,
                correlation: 0.2067991931,
                trend_line: 85.0586176056,
            },
            {
                datetime: "2023-05-19T11:54:03.000Z",
                overall_duration: 217.0,
                total: 1,
                correlation: 0.2068181524,
                trend_line: 28.9717376351,
            },
            {
                datetime: "2023-05-19T13:49:28.000Z",
                overall_duration: 1232.0,
                total: 2,
                correlation: 0.2068254928,
                trend_line: 29.6832227763,
            },
            {
                datetime: "2023-05-23T07:07:16.000Z",
                overall_duration: 314890.0,
                total: 7,
                correlation: 0.1999674786,
                trend_line: 232.7631519552,
            },
            {
                datetime: "2023-05-23T08:48:54.000Z",
                overall_duration: 903.0,
                total: 22,
                correlation: 0.1442659262,
                trend_line: 29.4526378773,
            },
            {
                datetime: "2023-05-23T11:05:11.000Z",
                overall_duration: 523.0,
                total: 10,
                correlation: 0.1442619045,
                trend_line: 29.1862677183,
            },
            {
                datetime: "2023-05-23T13:46:45.000Z",
                overall_duration: 274.0,
                total: 10,
                correlation: 0.1440770586,
                trend_line: 29.0117012849,
            },
            {
                datetime: "2023-05-23T14:34:51.000Z",
                overall_duration: 285.0,
                total: 2,
                correlation: 0.1440581301,
                trend_line: 29.0194134541,
            },
            {
                datetime: "2023-05-23T15:12:30.000Z",
                overall_duration: 508.0,
                total: 6,
                correlation: 0.6227149477,
                trend_line: 29.1757522032,
            },
            {
                datetime: "2023-05-24T09:57:45.000Z",
                overall_duration: 717.0,
                total: 1,
                correlation: 0.6227906902,
                trend_line: 29.3222621973,
            },
            {
                datetime: "2023-05-25T11:27:12.000Z",
                overall_duration: 166006.0,
                total: 361,
                correlation: 0.6422855441,
                trend_line: 140.766482856,
            },
            {
                datetime: "2023-05-26T16:02:07.000Z",
                overall_duration: 272.0,
                total: 1,
                correlation: 0.6432061468,
                trend_line: 29.0102990683,
            },
            {
                datetime: "2023-05-29T12:20:49.000Z",
                overall_duration: 260458.0,
                total: 83,
                correlation: 0.6218636227,
                trend_line: 200.1255793639,
            },
            {
                datetime: "2023-05-29T15:59:02.000Z",
                overall_duration: 261745.0,
                total: 28,
                correlation: 0.5787906127,
                trend_line: 200.9108899877,
            },
            {
                datetime: "2023-05-31T11:25:21.000Z",
                overall_duration: 9154.0,
                total: 23,
                correlation: 0.5782291552,
                trend_line: 35.225480932,
            },
            {
                datetime: "2023-06-01T18:30:23.000Z",
                overall_duration: 11386.0,
                total: 1,
                correlation: 0.5778074597,
                trend_line: 36.7835144924,
            },
            {
                datetime: "2023-06-02T11:09:19.000Z",
                overall_duration: 460.0,
                total: 1,
                correlation: 0.5777973053,
                trend_line: 29.1421020939,
            },
            {
                datetime: "2023-06-13T11:15:24.000Z",
                overall_duration: 581910.0,
                total: 128,
                correlation: 0.1639202026,
                trend_line: 374.2389694062,
            },
            {
                datetime: "2023-06-13T12:22:15.000Z",
                overall_duration: 191.0,
                total: 8,
                correlation: 0.2900062892,
                trend_line: 28.953508273,
            },
            {
                datetime: "2023-06-13T14:19:29.000Z",
                overall_duration: 478.0,
                total: 36,
                correlation: 0.3175013087,
                trend_line: 29.1547209673,
            },
            {
                datetime: "2023-06-13T15:04:37.000Z",
                overall_duration: 468.0,
                total: 6,
                correlation: 0.3172191959,
                trend_line: 29.1477104943,
            },
            {
                datetime: "2023-06-13T15:55:58.000Z",
                overall_duration: 292.0,
                total: 12,
                correlation: 0.316964604,
                trend_line: 29.024321179,
            },
            {
                datetime: "2023-06-14T12:01:27.000Z",
                overall_duration: 1122.0,
                total: 44,
                correlation: 0.3136116845,
                trend_line: 29.6061311967,
            },
            {
                datetime: "2023-06-14T15:11:46.000Z",
                overall_duration: 248.0,
                total: 39,
                correlation: 0.3138950334,
                trend_line: 28.9934723745,
            },
            {
                datetime: "2023-06-15T11:06:28.000Z",
                overall_duration: 266.0,
                total: 1,
                correlation: 0.3167625435,
                trend_line: 29.0060924113,
            },
            {
                datetime: "2023-06-20T12:37:14.000Z",
                overall_duration: 4789.0,
                total: 6,
                correlation: 0.3264072225,
                trend_line: 32.1740912557,
            },
            {
                datetime: "2023-06-21T11:09:14.000Z",
                overall_duration: 590929.0,
                total: 851,
                correlation: 0.644987122,
                trend_line: 378.4311965515,
            },
            {
                datetime: "2023-06-21T11:20:39.000Z",
                overall_duration: 217.0,
                total: 1,
                correlation: 0.6450901489,
                trend_line: 28.9717376351,
            },
            {
                datetime: "2023-06-21T12:34:57.000Z",
                overall_duration: 328.0,
                total: 30,
                correlation: 0.6448133931,
                trend_line: 29.0495606709,
            },
            {
                datetime: "2023-06-21T15:14:20.000Z",
                overall_duration: 2142.0,
                total: 73,
                correlation: 0.6420900563,
                trend_line: 30.3208387105,
            },
            {
                datetime: "2023-06-30T11:18:48.000Z",
                overall_duration: 185.0,
                total: 17,
                correlation: 0.6419697419,
                trend_line: 28.9493014679,
            },
            {
                datetime: "2023-06-30T11:38:38.000Z",
                overall_duration: 177.0,
                total: 10,
                correlation: 0.6480253475,
                trend_line: 28.9436923773,
            },
            {
                datetime: "2023-07-03T10:02:28.000Z",
                overall_duration: 6472.0,
                total: 1,
                correlation: 0.6479105417,
                trend_line: 33.3512994459,
            },
            {
                datetime: "2023-07-03T12:18:39.000Z",
                overall_duration: 3330.0,
                total: 1,
                correlation: 0.650453396,
                trend_line: 31.1528620617,
            },
            {
                datetime: "2023-07-04T11:14:52.000Z",
                overall_duration: 7899.0,
                total: 26,
                correlation: 0.6513733514,
                trend_line: 34.3487622474,
            },
            {
                datetime: "2023-07-04T11:52:42.000Z",
                overall_duration: 201.0,
                total: 1,
                correlation: 0.6677425419,
                trend_line: 28.9605195905,
            },
            {
                datetime: "2023-07-05T13:11:07.000Z",
                overall_duration: 218.0,
                total: 21,
                correlation: 0.6672736193,
                trend_line: 28.9724387603,
            },
            {
                datetime: "2023-07-06T15:21:37.000Z",
                overall_duration: 90207.0,
                total: 123,
                correlation: 0.6701775764,
                trend_line: 90.7909321288,
            },
            {
                datetime: "2023-07-07T10:59:31.000Z",
                overall_duration: 68609.0,
                total: 5,
                correlation: 0.6672965571,
                trend_line: 76.1922720132,
            },
            {
                datetime: "2023-07-07T11:22:32.000Z",
                overall_duration: 1282604.0,
                total: 671,
                correlation: 0.7769750332,
                trend_line: 559.5901147135,
            },
            {
                datetime: "2023-07-10T09:50:23.000Z",
                overall_duration: 237147.0,
                total: 12,
                correlation: 0.7687867459,
                trend_line: 185.7898033297,
            },
            {
                datetime: "2023-07-11T12:29:41.000Z",
                overall_duration: 176.0,
                total: 2,
                correlation: 0.7687793567,
                trend_line: 28.9429912396,
            },
            {
                datetime: "2023-07-17T08:43:18.000Z",
                overall_duration: 374.0,
                total: 6,
                correlation: 0.7689648548,
                trend_line: 29.0818105578,
            },
            {
                datetime: "2023-07-18T08:50:22.000Z",
                overall_duration: 563.0,
                total: 26,
                correlation: 0.7844637128,
                trend_line: 29.2143087564,
            },
            {
                datetime: "2023-07-18T10:56:30.000Z",
                overall_duration: 279.0,
                total: 2,
                correlation: 0.7844864298,
                trend_line: 29.0152068209,
            },
            {
                datetime: "2023-07-18T12:01:26.000Z",
                overall_duration: 307.0,
                total: 1,
                correlation: 0.7850229658,
                trend_line: 29.034837682,
            },
            {
                datetime: "2023-07-21T10:16:43.000Z",
                overall_duration: 37.0,
                total: 2,
                correlation: 0.7856647605,
                trend_line: 28.8455301339,
            },
            {
                datetime: "2023-07-24T15:43:52.000Z",
                overall_duration: 228.0,
                total: 9,
                correlation: 0.7856653363,
                trend_line: 28.9794499956,
            },
            {
                datetime: "2023-07-25T11:11:57.000Z",
                overall_duration: 248.0,
                total: 6,
                correlation: 0.7857778118,
                trend_line: 28.9934723745,
            },
            {
                datetime: "2023-08-01T12:42:38.000Z",
                overall_duration: 1888634.0,
                total: 553,
                correlation: 0.7759001478,
                trend_line: 433.1564564152,
            },
            {
                datetime: "2023-08-01T13:23:12.000Z",
                overall_duration: 197.0,
                total: 1,
                correlation: 0.7777215857,
                trend_line: 28.9577150672,
            },
            {
                datetime: "2023-08-01T16:27:05.000Z",
                overall_duration: 856.0,
                total: 13,
                correlation: 0.7776099744,
                trend_line: 29.4196944815,
            },
            {
                datetime: "2023-08-02T11:01:27.000Z",
                overall_duration: 108.0,
                total: 9,
                correlation: 0.7775592191,
                trend_line: 28.8953131611,
            },
            {
                datetime: "2023-08-02T11:39:15.000Z",
                overall_duration: 479.0,
                total: 2,
                correlation: 0.7861425768,
                trend_line: 29.1554220129,
            },
            {
                datetime: "2023-08-02T12:28:13.000Z",
                overall_duration: 213.0,
                total: 17,
                correlation: 0.7862097174,
                trend_line: 28.9689331313,
            },
            {
                datetime: "2023-08-03T09:04:40.000Z",
                overall_duration: 63082.0,
                total: 119,
                correlation: 0.7839760059,
                trend_line: 72.4317217271,
            },
            {
                datetime: "2023-08-03T09:38:53.000Z",
                overall_duration: 197.0,
                total: 4,
                correlation: 0.7840128405,
                trend_line: 28.9577150672,
            },
            {
                datetime: "2023-08-03T16:18:25.000Z",
                overall_duration: 22148.0,
                total: 23,
                correlation: 0.7837834606,
                trend_line: 44.2742172993,
            },
            {
                datetime: "2023-08-04T09:10:09.000Z",
                overall_duration: 1774.0,
                total: 16,
                correlation: 0.7836992225,
                trend_line: 30.0630200813,
            },
            {
                datetime: "2023-08-04T13:58:40.000Z",
                overall_duration: 51.0,
                total: 1,
                correlation: 0.7837046851,
                trend_line: 28.8553466271,
            },
            {
                datetime: "2023-08-04T16:25:17.000Z",
                overall_duration: 10071.0,
                total: 33,
                correlation: 0.8028621106,
                trend_line: 35.8657728333,
            },
            {
                datetime: "2023-08-08T11:18:49.000Z",
                overall_duration: 64838.0,
                total: 175,
                correlation: 0.796829304,
                trend_line: 73.6275794129,
            },
            {
                datetime: "2023-08-08T15:57:39.000Z",
                overall_duration: 9136.0,
                total: 59,
                correlation: 0.7971561008,
                trend_line: 35.2129099064,
            },
            {
                datetime: "2023-08-10T12:24:33.000Z",
                overall_duration: 81198.0,
                total: 85,
                correlation: 0.8013057102,
                trend_line: 84.7203143085,
            },
            {
                datetime: "2023-08-10T15:35:03.000Z",
                overall_duration: 2781.0,
                total: 18,
                correlation: 0.801363155,
                trend_line: 30.768420043,
            },
            {
                datetime: "2023-08-10T16:04:36.000Z",
                overall_duration: 216.0,
                total: 48,
                correlation: 0.8009113097,
                trend_line: 28.9710365096,
            },
            {
                datetime: "2023-08-11T10:55:27.000Z",
                overall_duration: 69919.0,
                total: 14,
                correlation: 0.800204767,
                trend_line: 77.0821254068,
            },
            {
                datetime: "2023-08-11T11:36:10.000Z",
                overall_duration: 88571.0,
                total: 6,
                correlation: 0.8069796536,
                trend_line: 89.6905444568,
            },
            {
                datetime: "2023-08-21T10:10:32.000Z",
                overall_duration: 26.0,
                total: 1,
                correlation: 0.8069717908,
                trend_line: 28.8378171331,
            },
            {
                datetime: "2023-08-21T11:33:15.000Z",
                overall_duration: 864246.0,
                total: 16,
                correlation: 0.751498745,
                trend_line: 484.9324358527,
            },
            {
                datetime: "2023-08-21T12:25:53.000Z",
                overall_duration: 2497.0,
                total: 8,
                correlation: 0.7514722599,
                trend_line: 30.5695104118,
            },
            {
                datetime: "2023-08-21T13:59:31.000Z",
                overall_duration: 256.0,
                total: 3,
                correlation: 0.7515396463,
                trend_line: 28.999081292,
            },
            {
                datetime: "2023-08-21T15:42:06.000Z",
                overall_duration: 1454.0,
                total: 1,
                correlation: 0.7522128783,
                trend_line: 29.8387963534,
            },
            {
                datetime: "2023-08-22T09:34:34.000Z",
                overall_duration: 183.0,
                total: 175,
                correlation: 0.7438134788,
                trend_line: 28.947899197,
            },
            {
                datetime: "2023-08-22T16:01:19.000Z",
                overall_duration: 99.0,
                total: 18,
                correlation: 0.7436789116,
                trend_line: 28.8890027216,
            },
            {
                datetime: "2023-08-22T16:16:05.000Z",
                overall_duration: 29.0,
                total: 3,
                correlation: 0.7437310878,
                trend_line: 28.8399206824,
            },
            {
                datetime: "2023-08-23T09:51:57.000Z",
                overall_duration: 160.0,
                total: 1,
                correlation: 0.8414451786,
                trend_line: 28.931772995,
            },
            {
                datetime: "2023-08-23T10:24:57.000Z",
                overall_duration: 535.0,
                total: 11,
                correlation: 0.8414559781,
                trend_line: 29.194680081,
            },
            {
                datetime: "2023-08-23T16:39:45.000Z",
                overall_duration: 10080.0,
                total: 65,
                correlation: 0.8400931326,
                trend_line: 35.8720557668,
            },
            {
                datetime: "2023-08-28T11:57:44.000Z",
                overall_duration: 1464.0,
                total: 3,
                correlation: 0.8424612056,
                trend_line: 29.8458038181,
            },
            {
                datetime: "2023-08-29T10:01:41.000Z",
                overall_duration: 314871.0,
                total: 2,
                correlation: 0.8327045851,
                trend_line: 232.7519684729,
            },
            {
                datetime: "2023-08-29T11:55:45.000Z",
                overall_duration: 183.0,
                total: 14,
                correlation: 0.8326646188,
                trend_line: 28.947899197,
            },
            {
                datetime: "2023-08-29T13:18:05.000Z",
                overall_duration: 13425.0,
                total: 18,
                correlation: 0.8325903188,
                trend_line: 38.2054820147,
            },
            {
                datetime: "2023-08-29T13:45:39.000Z",
                overall_duration: 250.0,
                total: 0,
                correlation: 0.8326123869,
                trend_line: 28.9948746057,
            },
            {
                datetime: "2023-09-01T10:43:43.000Z",
                overall_duration: 193.0,
                total: 3,
                correlation: 0.8328731066,
                trend_line: 28.9549105389,
            },
            {
                datetime: "2023-09-05T18:07:40.000Z",
                overall_duration: 24454.0,
                total: 0,
                correlation: 0.8326285666,
                trend_line: 45.8745786686,
            },
            {
                datetime: "2023-09-06T07:14:55.000Z",
                overall_duration: 295.0,
                total: 1,
                correlation: 0.8328170176,
                trend_line: 29.0264244851,
            },
            {
                datetime: "2023-09-07T11:34:42.000Z",
                overall_duration: 674556.0,
                total: 76,
                correlation: 0.8211286328,
                trend_line: 415.3224662788,
            },
            {
                datetime: "2023-09-07T13:59:13.000Z",
                overall_duration: 55.0,
                total: 0,
                correlation: 0.821757069,
                trend_line: 28.8581513285,
            },
            {
                datetime: "2023-09-07T14:35:54.000Z",
                overall_duration: 319.0,
                total: 0,
                correlation: 0.7829317092,
                trend_line: 29.043250835,
            },
            {
                datetime: "2023-09-12T07:21:21.000Z",
                overall_duration: 120.0,
                total: 0,
                correlation: 0.7883441602,
                trend_line: 28.9037270421,
            },
            {
                datetime: "2023-09-13T10:37:54.000Z",
                overall_duration: 114.0,
                total: 2,
                correlation: 0.7883447893,
                trend_line: 28.8995201071,
            },
            {
                datetime: "2023-09-13T11:30:59.000Z",
                overall_duration: 599.0,
                total: 0,
                correlation: 0.7883342251,
                trend_line: 29.2395452735,
            },
            {
                datetime: "2023-09-13T12:11:22.000Z",
                overall_duration: 65.0,
                total: 1,
                correlation: 0.7889048875,
                trend_line: 28.8651630605,
            },
            {
                datetime: "2023-09-15T06:29:27.000Z",
                overall_duration: 209.0,
                total: 2,
                correlation: 0.7889055609,
                trend_line: 28.9661286226,
            },
            {
                datetime: "2023-09-15T06:42:44.000Z",
                overall_duration: 195.0,
                total: 2,
                correlation: 0.7889099668,
                trend_line: 28.9563128037,
            },
            {
                datetime: "2023-09-15T09:47:43.000Z",
                overall_duration: 246438.0,
                total: 310,
                correlation: 0.7454182063,
                trend_line: 191.5288386048,
            },
            {
                datetime: "2023-09-15T15:01:05.000Z",
                overall_duration: 708.0,
                total: 5,
                correlation: 0.7454464504,
                trend_line: 29.315953429,
            },
            {
                datetime: "2023-09-19T09:39:09.000Z",
                overall_duration: 72231.0,
                total: 12,
                correlation: 0.7446196407,
                trend_line: 78.6512400419,
            },
            {
                datetime: "2023-09-25T11:57:22.000Z",
                overall_duration: 272073.0,
                total: 20,
                correlation: 0.2098739226,
                trend_line: 207.1892969136,
            },
            {
                datetime: "2023-09-25T14:07:55.000Z",
                overall_duration: 310.0,
                total: 2,
                correlation: 0.2097759517,
                trend_line: 29.0369409743,
            },
            {
                datetime: "2023-09-28T10:08:57.000Z",
                overall_duration: 226.0,
                total: 8,
                correlation: 0.2103126455,
                trend_line: 28.9780477509,
            },
            {
                datetime: "2023-10-02T13:37:27.000Z",
                overall_duration: 531.0,
                total: 0,
                correlation: 0.2111603258,
                trend_line: 29.191875965,
            },
            {
                datetime: "2023-10-03T15:09:20.000Z",
                overall_duration: 224.0,
                total: 36,
                correlation: 0.2072514563,
                trend_line: 28.9766455051,
            },
            {
                datetime: "2023-10-03T16:12:06.000Z",
                overall_duration: 878.0,
                total: 73,
                correlation: 0.1990673661,
                trend_line: 29.4351148783,
            },
            {
                datetime: "2023-10-04T09:38:21.000Z",
                overall_duration: 598.0,
                total: 20,
                correlation: 0.2040398236,
                trend_line: 29.2388442644,
            },
            {
                datetime: "2023-10-06T15:48:12.000Z",
                overall_duration: 778.0,
                total: 3,
                correlation: 0.2041076166,
                trend_line: 29.3650209757,
            },
            {
                datetime: "2023-10-09T15:42:21.000Z",
                overall_duration: 1469121.0,
                total: 763,
                correlation: 0.7432735544,
                trend_line: 552.8887868326,
            },
            {
                datetime: "2023-10-10T10:49:30.000Z",
                overall_duration: 429.0,
                total: 83,
                correlation: 0.7389745714,
                trend_line: 29.1203693583,
            },
            {
                datetime: "2023-10-10T11:04:54.000Z",
                overall_duration: 238.0,
                total: 9,
                correlation: 0.7388505671,
                trend_line: 28.9864612003,
            },
            {
                datetime: "2023-10-10T11:51:23.000Z",
                overall_duration: 316.0,
                total: 2,
                correlation: 0.7396390371,
                trend_line: 29.0411475508,
            },
            {
                datetime: "2023-10-10T14:32:24.000Z",
                overall_duration: 349.0,
                total: 3,
                correlation: 0.7518598627,
                trend_line: 29.0642835254,
            },
            {
                datetime: "2023-10-13T10:49:13.000Z",
                overall_duration: 247.0,
                total: 7,
                correlation: 0.7541596432,
                trend_line: 28.9927712585,
            },
            {
                datetime: "2023-10-13T11:03:42.000Z",
                overall_duration: 36.0,
                total: 0,
                correlation: 0.7560011559,
                trend_line: 28.8448289536,
            },
            {
                datetime: "2023-10-13T11:14:07.000Z",
                overall_duration: 268.0,
                total: 3,
                correlation: 0.7563700045,
                trend_line: 29.0074946315,
            },
            {
                datetime: "2023-10-13T14:11:00.000Z",
                overall_duration: 2259.0,
                total: 17,
                correlation: 0.7579615055,
                trend_line: 30.4027995535,
            },
            {
                datetime: "2023-10-13T14:35:58.000Z",
                overall_duration: 208.0,
                total: 1,
                correlation: 0.7585478243,
                trend_line: 28.9654274946,
            },
            {
                datetime: "2023-10-16T11:47:23.000Z",
                overall_duration: 1335.0,
                total: 1,
                correlation: 0.7596855574,
                trend_line: 29.7554051804,
            },
            {
                datetime: "2023-10-19T11:54:07.000Z",
                overall_duration: 157101.0,
                total: 1,
                correlation: 0.756065721,
                trend_line: 134.9997994277,
            },
            {
                datetime: "2023-10-23T09:45:30.000Z",
                overall_duration: 1531975.0,
                total: 646,
                correlation: 0.906947383,
                trend_line: 544.4905022693,
            },
            {
                datetime: "2023-10-23T12:33:42.000Z",
                overall_duration: 3351.0,
                total: 24,
                correlation: 0.9067388938,
                trend_line: 31.1675656637,
            },
            {
                datetime: "2023-10-23T16:34:33.000Z",
                overall_duration: 293.0,
                total: 7,
                correlation: 0.9067206341,
                trend_line: 29.0250222813,
            },
            {
                datetime: "2023-10-25T00:05:42.000Z",
                overall_duration: 114966.0,
                total: 2340,
                correlation: 0.377423756,
                trend_line: 107.3337354496,
            },
            {
                datetime: "2023-10-25T08:25:42.000Z",
                overall_duration: 2066.0,
                total: 6,
                correlation: 0.3804350777,
                trend_line: 30.267596948,
            },
            {
                datetime: "2023-10-25T09:01:04.000Z",
                overall_duration: 330.0,
                total: 3,
                correlation: 0.380629739,
                trend_line: 29.0509628533,
            },
            {
                datetime: "2023-10-25T10:48:12.000Z",
                overall_duration: 2770.0,
                total: 8,
                correlation: 0.3805442887,
                trend_line: 30.7607162557,
            },
            {
                datetime: "2023-10-25T13:15:00.000Z",
                overall_duration: 261.0,
                total: 1,
                correlation: 0.3805433813,
                trend_line: 29.0025868554,
            },
            {
                datetime: "2023-10-25T15:14:27.000Z",
                overall_duration: 3990.0,
                total: 21,
                correlation: 0.3803906098,
                trend_line: 31.6149107483,
            },
        ],
        explanation:
            "This is the graph is showing the correlation between PR duration and the PR lines of code.\n            Any data points above the 0.2 and below the -0.2 lines have a statistically significant correlation.\n            ",
        description:
            "It has been produced by calculating the correlation coefficient on a rolling PR window of 50 Pull Requests, in order to smoothen the curve and depict the general direction of the move while minimizing the noise. This means that we take a window of the 50 first PRs and we calculate the correlation coefficient, then we remove the oldest PR and we add a new one calculating again the correlation, and we keep doing that until we reach the end of the dataset, meaning the most recent PRs.\n            \n            These have been the best settings we have found to be working better for this calculation. However, we will allow you to set this settings in any value you see more fit.\n            \n            Any data points above the 0.2 line have a statistically significant positive correlation, meaning when one of the variable increases the other one does too. Also any data points below -0.2 represent a\n            statistically significant negative correlation, meaning when one variable increases the other one does reduce. The higher or lower from 0 a data point is the more positively or negatively our two variables are correlated indicatign that they potentially affect each other more.\n            ",
        error: null,
    },
};
export default mrDurationToTotalResp;
